import {ErrorHandler, Injectable, NgZone} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {NeqDialogService} from '@sharedcommon/services/dialog.service';
import {HttpErrorResponse} from '@angular/common/http';

@Injectable()
export class NeqErrorHandler implements ErrorHandler {

  constructor(
    private readonly dialogService: NeqDialogService,
    private readonly translateService: TranslateService,
    private readonly zone: NgZone
  ) {}

  handleError(err: any): void {
    if (!(err instanceof HttpErrorResponse) && err.rejection) {
      err = err.rejection;
    }

    if (err.status && err.status >= 500) {
      this.zone.run(() => {
        this.dialogService.showErrorDetail(err, this.translateService.instant('error.common.technical'));
      });
    } else if (err?.error?.message) {
      this.zone.run(() => {
        this.dialogService.showErrorDetail(err, this.translateService.instant(err.error.message));
      });
    }
    console.error(err);
  }
}
